import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import SearchBarContext from './context';
import { saveEvent } from '../../../../shared/search-event';

/* stylelint-disable property-no-vendor-prefix */
const Input = styled(animated.input)`
  &&&&& {
    -webkit-appearance: none;
    box-sizing: border-box;
    border: 0;
    border-radius: 4px 0px 0px 4px;
    padding: 0;
    background-color: ${props => props.theme.secondaryColorLight};
    height: 38px;
    font-weight: ${props => props.theme.fontWeightHeavy};
    font-size: 14px;
    line-height: 38px;
    color: ${props => props.theme.bodyColor};
    font-family: ${props => props.theme.fontFamilyBody};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &::placeholder {
    color: ${props => props.theme.secondaryColor};
    opacity: 0.75;
  }
`;
/* stylelint-enable property-no-vendor-prefix */

export default function InputBox() {
  const {
    state: {
      animation, expanded, query, width, value, pseudoMobile, inputFocus, showStockCodeTick,
    },
    dispatch,
  } = React.useContext(SearchBarContext);
  const inputRef = React.createRef();

  const {
    paddingLeft, paddingRight, w,
  } = useSpring({
    // eslint-disable-next-line no-nested-ternary
    paddingLeft: expanded ? (pseudoMobile ? '20px' : '50px') : '0px',
    // eslint-disable-next-line no-nested-ternary
    paddingRight: expanded ? `${((showStockCodeTick ? (pseudoMobile ? 54 : 64) : 0) + 60)}px` : '0px',
    w: expanded ? (width - (pseudoMobile ? 40 : 146)) : 0,
    immediate: !animation,
    onStart: () => inputRef.current && expanded && animation && inputRef.current.focus(),
    onRest: () => {
      if (inputRef.current) {
        if (expanded && animation) {
          if (!inputFocus) {
            dispatch({ type: 'inputFocus', payload: true });
          }
        } else {
          inputRef.current.blur();
        }
      }
    },
  });

  const onKeyUp = e => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      dispatch({ type: _.camelCase(e.key) });
    } else if (query !== value) {
      dispatch({ type: 'setQuery', payload: value });
    }
  };

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();

      if (value.length) {
        saveEvent({ query: value }).finally(() => {
          dispatch({ type: 'search' });
        });
      }
    }
  };

  const onClick = () => {
    if (expanded && !animation && inputRef.current) {
      const pos = value.length;
      inputRef.current.setSelectionRange(pos, pos);
    }
  };

  const placeholderText = (pseudoMobile || width < 450)
    ? 'Search Livewire'
    : 'Try searching stock codes, companies, contributor names or funds';

  return (
    <Input
      ref={inputRef}
      type="search"
      onChange={() => dispatch({ type: 'setValue', payload: inputRef.current.value })}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      onClick={onClick}
      value={value}
      placeholder={placeholderText}
      style={{
        paddingLeft,
        paddingRight,
        width: w.interpolate(v => `${v}px`),
      }}
    />
  );
}
